import { productVariantsService } from "../../api_client";

// Order lines reference Odoo `product.product` (variant) ids via
// PurchaseOrderLineDto.product / SaleOrderLineDto.product. Product details
// routes (/products/:id, /my-products/:id, /admin/products/:id) all expect the
// template id. This util fetches the variant to resolve its template id.
//
// TODO: backend should expose `productTemplateId` directly on the order-line
// DTOs so the extra round-trip can be removed.
export async function resolveProductRouteFromVariant(
  variantId: number,
  routePattern: string,
): Promise<string> {
  const { data } = await productVariantsService.getProductVariantById(variantId);
  const templateId = data.productTemplateId ?? variantId;
  const base = routePattern.replace(":id", String(templateId));
  return `${base}?variant=${variantId}`;
}
